import styles from '../../styles';
import React from 'react';
import { useSubscription } from '@apollo/client';
import { scheduledProcedure } from '../../../../../../graph/procedures';
import { format } from 'date-fns';
import { ZonedDateTime } from '@js-joda/core';
import MedicalPassportField from '../../components/MedicalPassportField';
import toSex from '../../../../../../questionnaire/toSex';
import toAge from '../../../../../../questionnaire/toAge';

// Not semantically same as other Pages, but it was asked from us to add it so this is the most painless way to do so
const Page8 = ({ procedureId }) => {
  const { data } = useSubscription(scheduledProcedure, {
    variables: { id: procedureId },
  });

  const procedureNotes = (data?.scheduledProcedure?.events || []).filter(event => event.type === 'Note');

  return (
    <div id="page7" className="page">
      <div
        style={{
          ...styles.center,
          marginBottom: '3em',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div />
          <h2>PreOp Notes</h2>
          <div></div>
        </div>
        <div
          style={{
            marginBottom: '0.4rem',
            width: '100%',
            display: 'grid',
            gridTemplateRows: '1fr 1fr',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <MedicalPassportField name="procedure.patient.name" label="Patient" fontWeight={'bold'} fontSize={16} />
            <MedicalPassportField name="dob" label="DOB" path={['demographicinformation', 'dob']} />
            <MedicalPassportField name="procedure.patient.providerId" label="MRN" />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <MedicalPassportField name="procedure.physician.name" label="Surgeon" />
            <MedicalPassportField name="sex" label="Sex" path={['demographicinformation', 'sex']} reducer={toSex} />
            <MedicalPassportField name="age" label="Age" path={['demographicinformation', 'dob']} reducer={toAge} />
            <MedicalPassportField name="procedure.serviceTime" label="DOS" />
          </div>
        </div>
      </div>
      {procedureNotes.map((note, index) => (
        <div key={index} style={{ marginBottom: '3em' }}>
          {index !== 0 && (
            <div
              style={{
                borderTop: '3px solid #bbb',
                marginTop: '2em',
              }}
            />
          )}
          <h4>{note.user.name}</h4>
          <span>{note.text}</span>
          <h4 style={{ fontWeight: 600, float: 'right', paddingTop: '1em' }}>
            {format(ZonedDateTime.parse(note.timestamp).toLocalDateTime().toString(), 'MM/DD/YYYY HH:mm:ss')}
          </h4>
        </div>
      ))}
    </div>
  );
};

export default Page8;
